/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_budget_prob_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We simulate thousands of possible race outcomes based on each driver’s recent form, qualifying pace, and track history to estimate how many points they’ll score. The probability bars show how likely each price outcome is.`)
};

const es_f1_budget_prob_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simulamos miles de posibles resultados de carrera basándonos en la forma reciente, el ritmo en clasificación y el historial en pista de cada piloto para estimar cuántos puntos conseguirán. Las barras de probabilidad muestran cuán probable es cada resultado de precio.`)
};

const de_f1_budget_prob_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir simulieren Tausende möglicher Rennergebnisse basierend auf der aktuellen Form, Qualifikationsleistung und Streckenhistorie jedes Fahrers, um zu schätzen, wie viele Punkte er erzielen wird. Die Wahrscheinlichkeitsbalken zeigen, wie wahrscheinlich jedes Preisergebnis ist.`)
};

const nl_f1_budget_prob_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We simuleren duizenden mogelijke race-uitkomsten op basis van de recente vorm, kwalificatiesnelheid en baanhistorie van elke coureur om te schatten hoeveel punten ze zullen scoren. De kansbalken tonen hoe waarschijnlijk elk prijsresultaat is.`)
};

const fr_f1_budget_prob_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nous simulons des milliers de résultats de course possibles en nous basant sur la forme récente, le rythme en qualification et l’historique de piste de chaque pilote pour estimer combien de points ils marqueront. Les barres de probabilité montrent la probabilité de chaque résultat de prix.`)
};

const it_f1_budget_prob_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simuliamo migliaia di possibili risultati di gara basandoci sulla forma recente, il ritmo in qualifica e lo storico in pista di ogni pilota per stimare quanti punti otterranno. Le barre di probabilità mostrano quanto è probabile ogni risultato di prezzo.`)
};

const pt_br2_f1_budget_prob_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simulamos milhares de resultados de corrida possíveis com base na forma recente, ritmo de classificação e histórico de pista de cada piloto para estimar quantos pontos eles vão marcar. As barras de probabilidade mostram a chance de cada resultado de preço.`)
};

const pt_f1_budget_prob_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simulamos milhares de resultados de corrida possíveis com base na forma recente, ritmo de qualificação e histórico de pista de cada piloto para estimar quantos pontos vão marcar. As barras de probabilidade mostram a probabilidade de cada resultado de preço.`)
};

const ja_f1_budget_prob_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`各ドライバーの最近の調子、予選ペース、サーキット実績に基づいて数千の可能なレース結果をシミュレーションし、獲得ポイントを推定します。確率バーは各価格結果の可能性を示しています。`)
};

const zh_f1_budget_prob_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们根据每位车手的近期状态、排位赛速度和赛道历史记录模拟数千种可能的比赛结果，以估算他们将获得多少积分。概率条显示每种价格结果的可能性。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_budget_prob_p2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_budget_prob_p2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_budget_prob_p2", locale)
	if (locale === "en") return en_f1_budget_prob_p2(inputs)
	if (locale === "es") return es_f1_budget_prob_p2(inputs)
	if (locale === "de") return de_f1_budget_prob_p2(inputs)
	if (locale === "nl") return nl_f1_budget_prob_p2(inputs)
	if (locale === "fr") return fr_f1_budget_prob_p2(inputs)
	if (locale === "it") return it_f1_budget_prob_p2(inputs)
	if (locale === "pt-BR") return pt_br2_f1_budget_prob_p2(inputs)
	if (locale === "pt") return pt_f1_budget_prob_p2(inputs)
	if (locale === "ja") return ja_f1_budget_prob_p2(inputs)
	return zh_f1_budget_prob_p2(inputs)
};